import InstructorTaskPanel from './InstructorTaskPanel';

export default InstructorTaskPanel;
